import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type IfspUnsavedFieldType = {
  isAnyTeamMemberFieldsChanged: boolean;
  isHealthAndEligibilityFieldsChanged: boolean;
  isOutComeProgressInfoFieldsChange: boolean;
  isServiceDeliveryFieldsChanged: boolean;
  isReporterFieldsChanged: boolean;
  isOtherDailyRoutineFieldsChanged: boolean;
};

const initialState: IfspUnsavedFieldType = {
  isAnyTeamMemberFieldsChanged: false,
  isHealthAndEligibilityFieldsChanged: false,
  isOutComeProgressInfoFieldsChange: false,
  isServiceDeliveryFieldsChanged: false,
  isReporterFieldsChanged: false,
  isOtherDailyRoutineFieldsChanged: false,
};
const ifspUnsavedFieldSlice = createSlice({
  name: 'ifspUnsavedFields',
  initialState,
  reducers: {
    updateIfspUnsavedFields: (
      state,
      action: PayloadAction<IfspUnsavedFieldType>,
    ) => {
      state.isAnyTeamMemberFieldsChanged =
        action.payload.isAnyTeamMemberFieldsChanged;
      state.isHealthAndEligibilityFieldsChanged =
        action.payload.isHealthAndEligibilityFieldsChanged;
      state.isOutComeProgressInfoFieldsChange =
        action.payload.isOutComeProgressInfoFieldsChange;
      state.isServiceDeliveryFieldsChanged =
        action.payload.isServiceDeliveryFieldsChanged;
      state.isReporterFieldsChanged = action.payload.isReporterFieldsChanged;
      state.isOtherDailyRoutineFieldsChanged =
        action.payload.isOtherDailyRoutineFieldsChanged;
    },
    resetIfspUnsavedFields: (state) => {
      state.isAnyTeamMemberFieldsChanged = false;
      state.isHealthAndEligibilityFieldsChanged = false;
      state.isOutComeProgressInfoFieldsChange = false;
      state.isServiceDeliveryFieldsChanged = false;
      state.isReporterFieldsChanged = false;
      state.isOtherDailyRoutineFieldsChanged = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('RESET_REDUX_APP_STATES', () => initialState);
  },
});

export const { updateIfspUnsavedFields, resetIfspUnsavedFields } =
  ifspUnsavedFieldSlice.actions;
export default ifspUnsavedFieldSlice.reducer;
